// Profile of Alina Tselinina, Spanish. Source of the profile page.
module.exports = {
  headline: 'AI / Software Engineer • Python, R & AWS',
  summary: 'Alina Tselinina es ingeniera de software con experiencia en ingeniería de datos, matemáticas aplicadas y aprendizaje automático, y trabaja actualmente en aplicaciones basadas en IA y sistemas agénticos. Tiene experiencia en la creación de API y pipelines de datos, en la modernización de aplicaciones mediante migración a la nube y en el desarrollo de servicios respaldados por ML. Se centra en conectar LLM y agentes de IA con sistemas de software fiables mediante flujos de trabajo estructurados, integraciones, pruebas y evaluación iterativa.',
  imageAlt: 'Retrato de Alina Tselinina',
  personal: {
    languages: 'Inglés, polaco',
    programmingLanguages: 'Python, R, SQL, Bash'
  },
  education: [
    {
      period: '2014 - 2017',
      field: 'Estudios: matemáticas financieras y actuariales',
      institution: 'Universidad Adam Mickiewicz, Poznan',
      degree: 'Título: máster'
    },
    {
      period: '2009 - 2014',
      field: 'Estudios: matemáticas',
      institution: 'Universidad Estatal de Bielorrusia, Minsk',
      degree: 'Título: grado'
    }
  ],
  skills: [
    {
      title: 'Programación',
      description: 'Python, R, SQL, Bash'
    },
    {
      title: 'IA y LLM',
      description: 'Claude, MCP, agentes de IA, adaptación de LLM, entrenamiento y evaluación de modelos'
    },
    {
      title: 'Nube y datos',
      description: 'AWS (Lambda, EC2, S3, Glue, RDS, Athena, Step Functions), Snowflake'
    },
    {
      title: 'Frameworks y API',
      description: 'FastAPI, Flask, Shiny, API REST, Swagger, JSON Schema, Jinja, lxml'
    },
    {
      title: 'Ingeniería de datos y DevOps',
      description: 'ETL, Airflow, Docker, Git, Linux, CI/CD'
    },
    {
      title: 'Bases de datos y orquestación',
      description: 'PostgreSQL, Camunda'
    },
    {
      title: 'Herramientas de Atlassian',
      description: 'Jira, Bitbucket, Confluence'
    }
  ],
  positions: [
    {
      period: 'Desde marzo de 2026',
      title: 'AI / Software Engineer, pAIoneer Labs',
      description: [
        'Ingeniería de agentes de IA, configuración de flujos de trabajo e integración de herramientas.',
        'Adaptación de LLM, entrenamiento y evaluación de modelos.',
        'Desarrollo e integración de aplicaciones basadas en IA.',
        'Computación cuántica: contribución al desarrollo de software para aplicaciones cuánticas.'
      ]
    },
    {
      period: 'Desde mayo de 2025',
      title: 'Senior Software Developer, Geninvo',
      description: [
        'Desarrollo de aplicaciones.',
        'Implementación de pruebas unitarias y de interfaz de usuario para respaldar la calidad de las aplicaciones.'
      ]
    },
    {
      period: 'Noviembre de 2022 - febrero de 2025',
      title: 'Senior Python Developer, T-Systems',
      description: [
        'Mantenimiento y mejora de pipelines de datos y de la orquestación de flujos de trabajo.',
        'Desarrollo de paquetes para la automatización de informes.'
      ]
    },
    {
      period: 'Julio de 2022 - octubre de 2022',
      title: 'Data Engineer, S&P Global',
      description: [
        'Desarrollo y mantenimiento de pipelines ETL.'
      ]
    },
    {
      period: 'Marzo de 2022 - junio de 2022',
      title: 'Python Developer, DevBridge',
      description: [
        'Diseño y desarrollo de API REST y servicios de backend.',
        'Implementación de la lógica de backend para el procesamiento de JSON.'
      ]
    },
    {
      period: 'Noviembre de 2020 - marzo de 2022',
      title: 'Senior Software Developer, Roche',
      description: [
        'Diseño y desarrollo de API REST y servicios de backend (prueba de concepto).',
        'Desarrollo y mantenimiento de pipelines ETL.',
        'Modernización de aplicaciones locales (on-premise) mediante la migración a AWS y la reescritura de código R en Python.',
        'Validación de XML y transformación a HTML.',
        'Desarrollo de aplicaciones web.'
      ]
    },
    {
      period: 'Mayo de 2020 - noviembre de 2020',
      title: 'Data Scientist, PSI Polska, Poznan',
      description: [
        'Diseño y desarrollo de API REST y servicios de backend con un modelo de aprendizaje automático en el backend.',
        'Desarrollo de un modelo de segmentación de clientes.'
      ]
    },
    {
      period: 'Enero de 2019 - abril de 2020',
      title: 'Advanced Data Scientist, Analyx, Poznan',
      description: [
        'Web scraping y desarrollo de pipelines de datos.',
        'Desarrollo de aplicaciones web.',
        'Modelización del marketing mix.',
        'Optimización de flujos de trabajo.'
      ]
    },
    {
      period: 'Mayo de 2018 - diciembre de 2018',
      title: 'Data Scientist, Poznan',
      description: [
        'Desarrollo de un proceso ETL.',
        'Mantenimiento de scripts de Bash.',
        'Atención al cliente y análisis ad hoc.'
      ]
    },
    {
      period: 'Abril de 2017 - abril de 2018',
      title: 'Junior Analyst, Poznan',
      description: [
        'Análisis de datos y creación de informes.',
        'Elaboración de documentación y presentaciones.'
      ]
    }
  ]
};
